const fileContentTypes = [
  'application/pdf',
  'application/xml',
  'application/zip',
  'application/msword',
  'application/vnd.ms-excel',
  'application/octet-stream',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel 2007 version and above .xlsx
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word 2007 version and above .docx
]

export const responseFileHandler = async (response: Response) => {
  const contentType = response.headers.get('Content-Type')
  const contentDisposition = response.headers.get('Content-Disposition')

  if (
    (contentType && fileContentTypes.some(type => contentType?.includes(type))) ||
    contentDisposition?.includes('attachment')
  ) {
    const fileNameMatch = contentDisposition?.match(/filename="(.+)"/)
    const fileName = fileNameMatch && fileNameMatch[1] ? fileNameMatch[1] : Date.now().toString()
    const link = document.createElement('a')
    const blob = window.URL.createObjectURL(await response.blob())

    link.href = blob
    link.target = '_blank'
    link.download = fileName
    link.click()

    return { data: null }
  }

  if (!contentType) {
    return response.text()
  }

  return response.json()
}
